import {
    setCookie,
    initMenuTrigger,
    initOpenInNewTab,
    addScollClass,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    initForm,
    faqService,
    initLazyBg,
    //initShow,
    // initVideoMouseControl,
    initFooterWriting,
    scrollSlider,
    initLottieLoader
} from './functions';

import GLightbox from 'glightbox';


import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin.js";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, TextPlugin, SplitText);


const mainApp = () => {

    initLottieLoader();

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    // initShow();

    // init video mouse control
    // initVideoMouseControl();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();



    // add scroll class to body  
    addScollClass('100px', 'scroll');
    addScollClass('100dvh', 'showbottom_btn_form');

    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();



    //start - contact form
    initForm();

    faqService();

    initFooterWriting();




}

document.addEventListener("DOMContentLoaded", mainApp, false);

(function () {
    const ua = navigator.userAgent;
    const vendor = navigator.vendor;
    const isSafari = /Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR|Android/.test(ua);
    const isAppleVendor = vendor === 'Apple Computer, Inc.';

    // Nowoczesne wykrycie iOS / iPadOS:
    const isTouchDevice = navigator.maxTouchPoints > 1;
    const isIOSLike = /iPad|iPhone|iPod/.test(ua) || (isTouchDevice && /Mac/.test(ua));

    // Dodaj klasę tylko dla Safari na macOS (nie iOS/iPadOS)
    if (isSafari && isAppleVendor && !isIOSLike) {
        document.documentElement.classList.add('is-safari');
    }
})();

(function ($) {
    // Debounce helper function
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    }

    const mainAppWithJquery = () => {





        $('.subpageHeader__goDown').click(function () {
            // Batch read operations to avoid forced reflow
            const targetOffset = $(this).offset().top;
            const targetHeight = $(this).height();
            $('html,body').animate({ 'scrollTop': (targetOffset - targetHeight) + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu-mob .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder').animate({ 'scrollTop': '0px' }, 0);
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu-mob .menu-item.active:last').removeClass('active');
            if ($('#primary-menu-mob .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu-mob .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });
        $('#primary-menu .menu-item-has-children').on('mouseover', function () {
            $('body').addClass('show_subMenu');
        });

        $('#primary-menu .menu-item-has-children').on('mouseleave', function () {
            $('body').removeClass('show_subMenu');
        });

        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (window.innerWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        if ($('.gTeam__holder').length > 0) {
            if (window.innerWidth >= 782) {

                scrollSlider('.gTeam__holder', '.gTeam__slider', '.gTeam__item:not(:nth-child(1))', '.gTeam__item');
            }
        }

        // Optimized mouse effects with single global listener
        let animationFrameId = null;
        const cursorElements = new Map();

        // Cache cursor element offsets to avoid forced reflows
        function cacheCursorOffsets() {
            cursorElements.clear();
            $('.cursor_bg_anim').each(function () {
                const $el = $(this);
                cursorElements.set(this, {
                    offset: $el.offset(),
                    element: $el
                });
            });
        }

        // Initialize cache and update on resize
        if ($('.cursor_bg_anim').length > 0) {
            cacheCursorOffsets();
            $(window).on('resize', debounce(cacheCursorOffsets, 200));
        }

        // Throttled mouse move handler using requestAnimationFrame
        const handleMouseMove = (e) => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }

            animationFrameId = requestAnimationFrame(() => {
                // Update cursor position
                if ($('.mainCursor').hasClass('mainCursor--active')) {
                    $('.mainCursor').css({
                        'left': e.clientX + 'px',
                        'top': e.clientY + 'px'
                    });
                }

                // Update cursor_bg_anim background using cached offsets
                $('.cursor_bg_anim:hover').each(function () {
                    const cached = cursorElements.get(this);
                    if (!cached) return;

                    const x = e.pageX - cached.offset.left;
                    const y = e.pageY - cached.offset.top;

                    $(this).find('.cursor_bg_anim__bg').css({
                        'left': x + 'px',
                        'top': y + 'px',
                        'opacity': 0.3
                    });
                });
            });
        };

        // Single global mousemove listener
        $(document).on('mousemove', handleMouseMove);

        if (window.innerWidth > 992) {
            $('.portfolio__imageVideo').removeAttr('autoplay');
        }

        // Portfolio items - simplified event handling
        $('.portfolio__item, .news').on('mouseenter', function () {
            $('.mainCursor').addClass('mainCursor--active');
            $(this).find('video').get(0)?.play();
        }).on('mouseleave', function () {
            $('.mainCursor').removeClass('mainCursor--active');
            $(this).find('video').get(0)?.pause();
        });

        // About us groups - optimized initialization
        if ($('.cursor_bg_anim').length > 0) {
            $('.cursor_bg_anim').each(function () {
                var bg = $('<div class="cursor_bg_anim__bg"></div>');
                $(this).prepend(bg);
            }).on('mouseleave', function () {
                $(this).find('.cursor_bg_anim__bg').css('opacity', 0);
            });
        }



        // GSAP animation for .subpageHeader__bgVideo scaling on scroll
        if ($('.subpageHeader__bgVideo').length > 0) {
            gsap.to('.subpageHeader__bgVideo', {
                scale: 1.4,
                scrollTrigger: {
                    trigger: '.subpageHeader',
                    start: 'top top',
                    end: '50% top',
                    scrub: 1.2,
                    //  markers: true,
                    ease: "power2.out",
                }
            });
        }



        $('.logo-slider__slider').slick({
            infinite: true,
            arrows: false,
            dots: false,
            autoplay: true,
            speed: 4000,
            autoplaySpeed: 0,
            variableWidth: true,
            centerMode: true,
            slidesToShow: 3,
            slidesToScroll: 2,
            pauseOnHover: false,
            cssEase: 'linear',
        });

        // GSAP animation for elements with .animUp class
        if ($('.animUp').length > 0) {
            gsap.set('.animUp', { position: 'relative', y: 100, opacity: 0 });
            $('.animUp').each(function (index, element) {

                gsap.to(element, {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 90%',
                        once: true,
                        // markers: true,
                    }
                });

            });


        }

        if ($('.gVideo').length > 0) {
            // Oblicz dynamiczne skalowanie na podstawie szerokości
            const gVideoElement = $('.gVideo')[0];
            const gVideoWidth = gVideoElement.offsetWidth; // Natywny JS zamiast jQuery dla lepszej wydajności
            const screenWidth = Math.min(window.innerWidth, 1920); // maksymalna szerokość 1920px
            const scaleFactor = 1 + (screenWidth - gVideoWidth) / gVideoWidth; // 0.2 to mnożnik dla intensywności efektu
            console.log(scaleFactor);
            if (window.innerWidth >= 992) {
                gsap.to('.gVideo__video', {
                    scale: scaleFactor,
                    scrollTrigger: {
                        trigger: '.gVideo',
                        start: 'top top',

                        scrub: false,
                        pin: '.gVideo',
                        end: '100% 50%',
                        endTrigger: '.gVideo',
                        pinSpacing: false,
                        // markers: true,
                        toggleActions: "play none none reverse",
                    }
                });

            } else {
                gsap.to('.gVideo__video', {
                    scale: scaleFactor,
                    scrollTrigger: {
                        trigger: '.gVideo',
                        start: 'top top',

                        scrub: false,
                        pin: '.gVideo',
                        end: $('.gVideo + .portfolio_anim_images').length > 0 ? 'bottom 120%' : '100% 50%',
                        endTrigger: $('.gVideo + .portfolio_anim_images').length > 0 ? $('.gVideo + .portfolio_anim_images') : '.gVideo',
                        pinSpacing: false,
                        // markers: true,
                        toggleActions: "play none none reverse",
                    }
                });
            }

        }
        if ($('.portfolio_anim_images').length > 0) {
            const container = $('.portfolio_anim_images');
            const images = container.find('.wp-block-image');
            const totalImages = images.length;

            if (totalImages > 1) {
                // Ustaw z-index dla wszystkich obrazów
                images.each(function (index) {
                    // $(this).css('z-index', totalImages + index);
                    if (window.innerWidth >= 992) {
                        let st = ScrollTrigger.create({
                            trigger: $(this),
                            pin: $(this),
                            start: "top top",

                            endTrigger: ".portfolio_anim_images",
                            end: "bottom bottom",
                            pinSpacing: false,
                            //   markers: true,
                        });
                    } else {
                        let st = ScrollTrigger.create({
                            trigger: $(this),
                            pin: $(this),
                            start: "50% 50%",

                            endTrigger: ".portfolio_anim_images",
                            end: "bottom " + ($(this).height() / 2 + window.innerHeight / 2) + 'px',
                            pinSpacing: false,
                            //markers: true,
                        });
                    }
                });



                /*  // Stwórz timeline dla animacji
                     const tl = gsap.timeline({
                         scrollTrigger: {
                             trigger: container,
                             start: 'top top',
                             end: `+=${window.innerHeight * (totalImages - 1)}`,
                             scrub: 1,
                             pin: true,
                             pinSpacing: true,
                             markers: true,
                         }
                     });
                     */


            }


        }

        if ($('.text_highlight_anim').length > 0) {
            $('.text_highlight_anim').each(function () {
                // Use GSAP SplitText to split words while preserving HTML structure
                const split = new SplitText(this, {
                    type: "words",
                    wordsClass: "text_highlight_anim__inner"
                });

                // GSAP animation for highlighting words
                const $element = $(this);
                const words = $element.find('.text_highlight_anim__inner');
                const wordsCount = words.length;

                if (wordsCount > 0) {
                    // Create timeline for this specific element
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: this,
                            start: "top 80%",
                            end: "bottom 20%",
                            scrub: true,
                            //  markers: true, // uncomment for debugging
                            onUpdate: (self) => {
                                // Calculate which word should be highlighted based on progress
                                const progress = self.progress;
                                const currentWordIndex = Math.floor(progress * wordsCount);

                                // Remove highlight from all words
                                words.removeClass('highlight');

                                // Add highlight to words up to current index
                                for (let i = 0; i <= currentWordIndex && i < wordsCount; i++) {
                                    $(words[i]).addClass('highlight');
                                }
                            }
                        }
                    });
                }
            });
        }



        if ($('.subpageHeader__bulb').length > 0) {
            window.setTimeout(() => {
                let bulbT = gsap.timeline();

                bulbT.from('.subpageHeader__bulbImage.img1', {
                    z: -10,
                    opacity: 0,
                    duration: 0.8,
                    delay: 0.4,
                    ease: "power2.out"

                });
                bulbT.from('.subpageHeader__bulbImage.img2', {
                    z: 10,
                    opacity: 0,
                    duration: 1,
                    delay: -0.4,
                    ease: "power2.out"

                });
                bulbT.from('.subpageHeader__bulbImage.img3', {
                    z: 10,
                    opacity: 0,
                    duration: 1.4,
                    delay: -0.4,
                    ease: "power2.out"

                });
                $('.subpageHeader__bulb').css('opacity', 1);


            }, 100);
            gsap.fromTo('.subpageHeader__bulbImage.img1', {
                z: 0,
                duration: 1,
            }, {
                z: -30,
                duration: 1,
                ease: "none",

                scrollTrigger: {
                    trigger: '.subpageHeader',
                    start: "top top",
                    end: "bottom 50%",
                    scrub: 1,

                    // markers: true,
                    // once: true,
                },
            });
            gsap.fromTo('.subpageHeader__bulbImage.img3', {
                z: 0,
                duration: 1,
            }, {
                z: 30,
                duration: 1,
                ease: "none",

                scrollTrigger: {
                    trigger: '.subpageHeader',
                    start: "top 5%",
                    end: "bottom 50%",
                    scrub: 1,
                    // toggleActions: "play complete reverse reset",
                    // markers: true,
                    // once: true,
                },
            });

        }



        // Funkcja do inicjalizacji animacji pArch
        const initPArchAnimations = () => {
            if (document.querySelector('body.page-template-page-list')) {
                const pArch = document.querySelectorAll('.pArch__item.show'); // tylko widoczne elementy
                if (pArch.length > 0) {
                    [...pArch].forEach((item) => {
                        gsap.fromTo(item, {
                            y: 30,
                            opacity: 0,
                        }, {
                            y: 0,
                            opacity: 1,
                            duration: 1,
                            ease: "linear",
                            scrollTrigger: {
                                trigger: item,
                                start: "top 85%",
                                end: "top 55%",
                                scrub: true,
                                // markers: true,
                            },
                        });
                    });
                }
            }
        };

        $('.tableOfContents__link').click(function () {
            let targetHtml = $(this).attr('data-target');

            let target = $('.mainContent .contentUi h2').filter(function () {
                return $(this).html() === targetHtml;
            });

            if (target.length > 0) {
                // Batch read operations to avoid forced reflow
                const targetTop = target.offset().top;
                $('html,body').animate({ 'scrollTop': (targetTop - 120) + 'px' }, 500);
            } else {
                // Fallback - spróbuj przez tekst
                let targetText = $(this).text();
                let backupTarget = $('.mainContent .contentUi h2').filter(function () {
                    return $(this).text().trim() === targetText.trim();
                });
                if (backupTarget.length > 0) {
                    const backupTargetTop = backupTarget.offset().top;
                    $('html,body').animate({ 'scrollTop': (backupTargetTop - 120) + 'px' }, 500);
                }
            }
        });



        //portfolio filtering
        if (document.querySelector('.projects')) {
            const catAll = document.querySelectorAll('.projects .portfolio__item, .pArch__item').length;
            const cat1 = document.querySelectorAll('.projects .portfolio__item.cat_1, .pArch__item.cat_1').length;
            const cat2 = document.querySelectorAll('.projects .portfolio__item.cat_2, .pArch__item.cat_2').length;
            const cat3 = document.querySelectorAll('.projects .portfolio__item.cat_3, .pArch__item.cat_3').length;
            $('.portfolioMenu__menuItem.mit_1 .num').text('(' + catAll + ')');
            $('.portfolioMenu__menuItem.mit_2 .num').text('(' + cat1 + ')');
            $('.portfolioMenu__menuItem.mit_3 .num').text('(' + cat2 + ')');
            $('.portfolioMenu__menuItem.mit_4 .num').text('(' + cat3 + ')');
            $('.portfolioMenu__menuItem').click(function () {
                window.location.hash = $(this).data('href');
                if (!$(this).hasClass('active')) {
                    let ob = $(this);
                    let num = ob.data('target');
                    $('.portfolioMenu__menuItem').removeClass('active');
                    ob.addClass('active');

                    // CZYŚĆ wszystkie ScrollTrigger instances dla pArch__item
                    ScrollTrigger.getAll().forEach(trigger => {
                        if (trigger.trigger && trigger.trigger.classList.contains('pArch__item')) {
                            trigger.kill();
                        }
                    });


                    let portfolioChange = gsap.timeline();
                    portfolioChange.fromTo('.portfolio', {
                        opacity: 1,
                        y: 0,
                        duration: 0.3,
                        ease: "power2.in"

                    }, {
                        opacity: 0,
                        y: 20,
                        onComplete: () => {
                            if (num == 0) {
                                $('.portfolio__item, .pArch__item').removeClass('show');
                                $('.portfolio__item, .pArch__item').addClass('show');
                            } else {
                                $('.portfolio__item, .pArch__item').removeClass('show');
                                $('.portfolio__item.cat_' + num + ',.pArch__item.cat_' + num).addClass('show').focus();
                            }




                            //shufle
                            var ul = document.querySelector('.portfolio__container');
                            for (var i = ul.children.length; i >= 0; i--) {
                                ul.appendChild(ul.children[Math.random() * i | 0]);
                            }
                            // REINICJALIZUJ animacje pArch po filtrowaniu
                            initPArchAnimations();

                        }
                    });

                    portfolioChange.fromTo('.portfolio', {
                        opacity: 0,
                        y: 20,
                        duration: 0.5,
                        delay: 0.5,
                        ease: "power2.out"
                    }, {
                        opacity: 1,
                        y: 0
                    });

                    window.dispatchEvent(new Event('resize'));


                    //...

                }
            });
            // Zastąp oryginalną animację pArch tą funkcją:
            initPArchAnimations();
            if (window.location.hash != '') {
                console.log(window.location.hash);
                $('.portfolioMenu__menuItem[data-href="' + window.location.hash.replace('#', '') + '"]').trigger('click');
            }

        }



        gsap.from('.gDyn__num', {
            textContent: "0",
            duration: 3,
            ease: "power1.inOut",
            modifiers: {
                textContent: value => Math.round(value)
            },
            scrollTrigger: {
                trigger: '.gDyn__inner',
                start: "center 80%",
                // once: true,

                //markers: true
            }
        });
        gsap.from('.gDyn__barInner', {
            scaleX: 0,
            duration: 3,
            ease: "power1.out",
            modifiers: {
                textContent: value => Math.round(value)
            },
            scrollTrigger: {
                trigger: '.gDyn__inner',
                start: "center 80%",
                // once: true,

                //markers: true
            }
        });

        $('.projectsSlider__slider').slick({
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: false,
            speed: 1000,
            //  autoplaySpeed: 3000,
            slidesToShow: 2.5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]

        });

        // paralax images
        const gParalaxImages = document.querySelectorAll('.gParalax');
        if (gParalaxImages.length > 0) {
            [...gParalaxImages].forEach((item) => {
                const bg = item.querySelector('.gParalax__inner');
                // Cache dimensions to avoid forced reflow
                const itemRect = item.getBoundingClientRect();
                const itemHeight = itemRect.height;

                gsap.set(bg, { y: -itemHeight })
                gsap.to(bg, {
                    y: itemHeight / 3,
                    ease: "none",
                    scrollTrigger: {
                        trigger: item,
                        scrub: window.innerWidth > 992 ? true : 1,
                        // markers: true,
                        //    start: "top 100%",
                        //    end: "bottom 100px"
                    }
                });


            });
        }





        $('.show_popup_form, a[href="#show_popup_form"]').click(function (e) {
            e.preventDefault();

            $('body').addClass('showPopup');
            return false;
        });
        $('.contactPopup__close, .contactPopup').click(function (e) {
            e.preventDefault();
            $('body').removeClass('showPopup');
            window.setTimeout(() => {
                $('.contactPopup').removeClass('send');
                // $('.wpcf7-response-output').html('');
                // $('.contactPopup .wpcf7-form').attr('class', 'wpcf7-form init');

                // $('.contactPopup .wpcf7-form')['0'].reset();
            }, 1000);

            return false;
        });
        $('.contactPopup__content').click(function (e) {
            e.stopPropagation();
        });

        // Email validation function
        function validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }

        // Quick form email submission handler
        $('.subpageHeader__quickFormBtn').click(function (e) {
            e.preventDefault();

            const emailInput = $('.subpageHeader__quickFormInput');
            const email = emailInput.val().trim();

            if (!email) {
                emailInput.addClass('error');
                emailInput.focus();
                return false;
            }

            if (!validateEmail(email)) {
                emailInput.addClass('error');
                emailInput.focus();
                return false;
            }

            // Remove error class if validation passes
            emailInput.removeClass('error');

            // Add showPopup class to body
            $('body').addClass('showPopup');

            // Populate the email field in the contact popup
            $('input[name="formEmail"]').val(email);
            $('input[name="formEmail"]').parents('.contactform__field').find('label').addClass('show');
            $('input[name="formEmail"]').focus();

            return false;
        });








        const lightbox = GLightbox({
            selector: ".glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a",
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });


        // zmiana tytułu strony po zmianie widoczności
        const originalTitle = document.title;
        let dotsInterval;

        const handleVisibilityChange = () => {
            if (document.hidden) {
                // Clear any existing interval first
                clearInterval(dotsInterval);

                let dotCount = 1; // Start with 1 dot
                let baseTitle = "";
                if (document.querySelector('body').classList.contains('lang_en')) {
                    baseTitle = "We’ve got ideas for you";
                } else {
                    baseTitle = "Czekamy z pomysłami";
                }

                // Set initial title
                document.title = baseTitle + ' .';

                // Use simple setInterval instead of Web Worker to avoid CSP issues
                dotsInterval = setInterval(() => {
                    dotCount++;
                    if (dotCount > 3) dotCount = 1;
                    const dots = '.'.repeat(dotCount);
                    document.title = baseTitle + ' ' + dots;
                }, 600);

            } else {
                // Clear animation and restore original title
                clearInterval(dotsInterval);
                document.title = originalTitle;
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);





